import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, spacing }: Theme) {
    const backgroundColor = palette.divider;
    const dividerColor = palette.divider;
    const dividerBorder = `1px solid ${dividerColor}`;
    const darkBorder = `1px solid ${palette.action.disabledBackground}`;

    return {
        root: {
            paddingBottom: spacing(1),
        },
        colorBackground: {
            backgroundColor,
        },
        divider: {
            borderTop: dividerBorder,
            '&$colorBackground': {
                borderTop: darkBorder,
            },
        },
    };
}